<div
  class="admin-data-table-wrapper"
  [class.admin-data-table-wrapper--desktop-only]="variant() === 'desktop-only'"
>
  <table class="admin-data-table">
    <thead>
      <tr>
        @for (col of columns(); track col.id) {
          <th [class]="col.thClass">{{ col.headerKey | translate }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rows(); track trackRow(row)) {
        <tr>
          <ng-container
            *ngTemplateOutlet="rowTemplate(); context: { $implicit: row }"
          />
        </tr>
      }
    </tbody>
  </table>
</div>
